import styled from "styled-components";

export const Wrapper = styled.div`  
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
`;

export const Content =  styled.div`
    background: var(--white);
    min-height: var(--minHeight);
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    align-content: flex-start;
    height: 100%;
    width: 90%;
    padding: 20px;
    @media only screen and (min-width: 768px) {
        width: 80%;
        flex-direction: row;
    }
    @media only screen and (min-width: 1024px) {
        width: 70%;
    }
`;

export const Topbar =  styled.div`
    background: var(--blue);
    display: flex;
    flex-direction: row;
    align-items: center;  
    align-content: flex-start;  
    justify-content: flex-start;    
    height: 100px;
    width: 90%;
    @media only screen and (min-width: 768px) {
        width: 80%;
    }
    @media only screen and (min-width: 1024px) {
        width: 70%;
    }
`;

export const Textbar = styled.div`
    color: transparent;
    text-shadow: 0 0 0 var(--white);
    margin-left: 20px;
    font-size: 2em;
    font-weight: 800;
    @media only screen and (min-width: 1024px) {
        font-size: 2.5em;
    }
`;

export const Pathbar = styled.div`
    background: var(--white);
    display: flex;
    flex-direction: row;
    align-items: center;  
    align-content: flex-start;  
    justify-content: flex-start;    
    height: 30px;
    width: 90%;
    @media only screen and (min-width: 768px) {
        width: 80%;
    }
    @media only screen and (min-width: 1024px) {
        width: 70%;
    }
`;

export const Textpath = styled.div`
    color: transparent;
    text-shadow: 0 0 0 var(--black);
    font-size: 0.9em;
    margin-left: 20px;
`;

export const TextLink = styled.div`
    color: var(--black);
    font-size: 0.9em;
    margin-left: 20px;
    :hover {
        color: var(--blue);
    }
`;

export const Arrowright = styled.img`
    margin-left: 2px;
    margin-right: -17px;
    margin-top: -1.5px;
`;

export const LinksContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const LinkText = styled.a`
    text-decoration: none;
    background-color: var(--lightGrey);
    border: 1px solid transparent;
    border-radius: 6px;
    font-size: 1.0em;
    margin: 0 0 16px 0;
    padding: 12px;
    color: black;
    :hover {
        font-weight: bold;
        border: 1px solid gray;
    }
`;







